// İl-İlçe Veri Servisi
class CityDistrictService {
  constructor() {
    this.cities = null;
    this.districtsCache = new Map();
  }

  // İl listesini yükle
  async loadCities() {
    if (this.cities) {
      return this.cities;
    }

    try {
      // JSON dosyasından çek
      const citiesModule = await import('../data/districts/index.json');
      this.cities = citiesModule.default.cities;
      return this.cities;
    } catch (error) {
      console.error('İl listesi yükleme hatası:', error);
      // Fallback: API'den çek
      return this.loadCitiesFromAPI();
    }
  }

  // API'den il listesini çek (fallback)
  async loadCitiesFromAPI() {
    try {
      const response = await fetch('http://localhost:3001/api/address/cities');
      const data = await response.json();
      
      if (data.success) {
        this.cities = data.data.map(city => ({
          id: city.id,
          name: city.name,
          cityPlate: city.cityPlate,
          fileName: `${city.id}_${city.name.toLowerCase().replace(/[^a-z0-9]/g, '_')}.json`
        }));
        return this.cities;
      }
    } catch (error) {
      console.error('API\'den il listesi çekme hatası:', error);
    }
    
    return [];
  }

  // Belirli bir il için ilçe listesini yükle
  async loadDistrictsForCity(cityId) {
    // Cache'de varsa döndür
    if (this.districtsCache.has(cityId)) {
      return this.districtsCache.get(cityId);
    }

    try {
      // İl bilgisini bul
      const cities = await this.loadCities();
      const city = cities.find(c => c.id === cityId);
      
      if (!city) {
        throw new Error(`İl bulunamadı: ${cityId}`);
      }

      // JSON dosyasından ilçeleri yükle
      const districtsModule = await import(`../data/districts/${city.fileName}`);
      const districts = districtsModule.default.districts || [];
      
      // Cache'e kaydet
      this.districtsCache.set(cityId, districts);
      
      return districts;
    } catch (error) {
      console.error(`İlçe listesi yükleme hatası (İl ID: ${cityId}):`, error);
      // Fallback: API'den çek
      return this.loadDistrictsFromAPI(cityId);
    }
  }

  // API'den ilçe listesini çek (fallback)
  async loadDistrictsFromAPI(cityId) {
    try {
      const response = await fetch(`http://localhost:3001/api/address/towns?cityId=${cityId}`);
      const data = await response.json();
      
      if (data.success) {
        const districts = data.data || [];
        this.districtsCache.set(cityId, districts);
        return districts;
      }
    } catch (error) {
      console.error(`API'den ilçe listesi çekme hatası (İl ID: ${cityId}):`, error);
    }
    
    return [];
  }

  // İl adına göre ilçeleri yükle
  async loadDistrictsByCityName(cityName) {
    const cities = await this.loadCities();
    const city = cities.find(c => c.name.toLowerCase() === cityName.toLowerCase());
    
    if (city) {
      return this.loadDistrictsForCity(city.id);
    }
    
    return [];
  }

  // Cache'i temizle
  clearCache() {
    this.districtsCache.clear();
    this.cities = null;
  }

  // Belirli bir ilin cache'ini temizle
  clearCityCache(cityId) {
    this.districtsCache.delete(cityId);
  }

  // Cache durumunu kontrol et
  getCacheStatus() {
    return {
      citiesLoaded: !!this.cities,
      citiesCount: this.cities ? this.cities.length : 0,
      districtsCached: this.districtsCache.size,
      cachedCities: Array.from(this.districtsCache.keys())
    };
  }

  // İlçe bilgilerini filtrele (teslimat alanına göre)
  filterDistrictsByDelivery(districts, includePartial = true) {
    return districts.filter(district => {
      if (includePartial) {
        return district.inDistributionArea === true;
      }
      return district.inDistributionArea === true && district.partial === false;
    });
  }

  // İlçe bilgilerini filtrele (toplama alanına göre)
  filterDistrictsByCollection(districts, includePartial = true) {
    return districts.filter(district => {
      if (includePartial) {
        return district.inCollectionArea === true;
      }
      return district.inCollectionArea === true && district.partial === false;
    });
  }

  // İlçe detaylarını al
  getDistrictDetails(districts, districtName) {
    return districts.find(district => 
      district.name.toLowerCase() === districtName.toLowerCase()
    );
  }

  // Xdock bilgilerini al
  getXdockInfo(districts, districtName) {
    const district = this.getDistrictDetails(districts, districtName);
    return district ? district.xdock : null;
  }
}

// Singleton instance
const cityDistrictService = new CityDistrictService();

export default cityDistrictService;
